import React, { useState } from 'react';
import './css/banner.css';
import bannerImage from '../../img/banner.png';
import ApplicationPopup from '../Popup/ApplicationPopup';

const Banner = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const openPopup = () => {
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <section className="banner">
        <div className="container banner-container">
          {/* Левый блок */}
          <div className="banner-content">
            <h1 className="banner-title">
              Безопасный контур<br />
            </h1>
            <p className="banner-description">
              ПО для поиска и классификации документов с персональными данными, соответствующая требованиям ФЗ-152.
            </p>
            <button className="banner-button" onClick={openPopup}>
              Оставить заявку
            </button>
          </div>

          {/* Правый блок */}
          <div className="banner-image-wrapper">
            <img
              className="banner-img"
              src={bannerImage}
              alt="Иллюстрация продукта"
            />
          </div>
        </div>
      </section>

      {/* Попап оставления заявки */}
      <ApplicationPopup type="Баннер" isOpen={isPopupOpen} onClose={closePopup} />
    </>
  );
};

export default Banner;